import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import VerifyPage from './pages/VerifyPage';
import DesktopConnectPage from './pages/DesktopConnectPage';
import { isAuthenticated } from '../../app/auth';

const LoginRoute = () => {
  const [searchParams] = useSearchParams();
  const desktopReturn = searchParams.get('desktop_return');
  if (isAuthenticated()) {
    if (desktopReturn) {
      try {
        sessionStorage.setItem('eagle_desktop_return', desktopReturn);
      } catch (_) {}
      return <Navigate to={`/desktop/connect?return=${encodeURIComponent(desktopReturn)}`} replace />;
    }
    return <Navigate to="/" replace />;
  }
  return <LoginPage />;
};

export const authRoutes = [
  { path: '/login', element: <LoginRoute /> },
  { path: '/verify', element: <VerifyPage /> },
  { path: '/desktop/connect', element: <DesktopConnectPage /> },
];
